import { render, staticRenderFns } from "./ProhibitionIcon.vue?vue&type=template&id=5a0b6c7c&"
import script from "./ProhibitionIcon.vue?vue&type=script&lang=ts&"
export * from "./ProhibitionIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports